import type { TemplateAssignmentScope } from '@Application/Documents/TemplateAssignments/TemplateAssignmentScope';

/** Renders the URL prefix for a scope; the `/api` prefix and host are added by the caller. */
const templateAssignmentScopePath = (scope: TemplateAssignmentScope): string => {
	switch (scope.type) {
		case 'organization': {
			return `organizations/${scope.id}/template-assignments`;
		}
		case 'facility': {
			return `facilities/${scope.id}/template-assignments`;
		}
	}
};

export default templateAssignmentScopePath;
